export default {
  namespaced: true,
  state: {
    selectedProducts: [],
  },
  getters: {
    selectedProducts: state => {
      return state.selectedProducts;
    },
  },
  actions: {
    changeProductAmountBy: (context, { amount, productId }) => {
      context.commit("changeProductAmountBy", { amount, productId });
    },
  },
  mutations: {
    changeProductAmountBy: (state, { amount, productId }) => {
      const product = state.selectedProducts.find(p => p.id === productId);
      if (product) {
        product.amount += amount;
      } else {
        state.selectedProducts.push({ amount: 1, id: productId });
      }
    },
  },
};
